import { useMemo } from "react";
import { View, Pressable, StyleSheet } from "react-native";
import { faShareAlt, faGlobe } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "../../platform";
import { COLORS } from "../../theme/colors";
import { share, handleLinkingPress } from "../../utils/helper";
import { platform } from "../../platform";

const headerIconSize = platform === "web" ? "2xl" : 21;

const ParkDetailsHeaderButtons = ({ parkData }) => {
  const headerButtonsPress = useMemo(
    () => ({
      onShare: () => {
        const url = `\n\n${process.env.REACT_APP_APPURL}/details/${encodeURI(parkData.title)}`;
        const message = `Check out ${parkData.title} at ${parkData.address}. ${url}`;
        share(message, parkData.name);
      },
      onWebsite: () => {
        handleLinkingPress(parkData?.url);
      },
    }),
    [parkData]
  );

  return (
    <View style={styles.headerButtons}>
      <Pressable
        onPress={headerButtonsPress.onShare}
        accessible={true}
        testID="share-button"
        accessibilityRole="button"
        accessibilityLabel="Share"
      >
        <FontAwesomeIcon icon={faShareAlt} size={headerIconSize} color={COLORS.tertiary} />
      </Pressable>
      {parkData?.url && (
        <Pressable
          onPress={headerButtonsPress.onWebsite}
          accessible={true}
          testID="website-button"
          accessibilityRole="button"
          accessibilityLabel="Website"
        >
          <FontAwesomeIcon icon={faGlobe} size={headerIconSize} color={COLORS.tertiary} />
        </Pressable>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  headerButtons: {
    marginRight: 10,
    flexDirection: "row",
    gap: 15,
  },
});

export default ParkDetailsHeaderButtons;
